import React, { Component } from "react";
import { connect } from "react-redux";
import ReactGA from "react-ga";

import Sidebar from "./Sidebar";

class SidebarContainer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Sidebar
                company={this.props.company}
                // menuItems={this.props.sidebar_menu}
                pathname={this.props.location.pathname}
                current_view_filter={this.props.current_view_filter}
                filters={this.props.filters}
                teamsIBelongToOptions={this.props.teamsIBelongToOptions}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        company: state.globalReducer.company,
        user: state.globalReducer.user,
        // sidebar_menu: state.globalReducer.sidebar_menu,
        packageObj: state.globalReducer.packageObj,
        current_view_filter: state.globalReducer.current_view_filter,
        filters: state.globalReducer.filters,
        teamsIBelongToOptions: state.rawDataReducer.teamsIBelongToOptions,
    };
};

export default connect(mapStateToProps)(SidebarContainer);
